module.exports = __webpack_public_path__ + "static/logo-og-b30ffc95b0ab207ef0fce254c3c541f4.png";